import {
  Avatar, Stack, Switch, Table, TableBody, TableCell, TableContainer, TableHead,
  TableRow, Typography
} from '@mui/material';
import { penalty, pointsNextStep, pointsPreviousStep } from '../../../actions/points';
import { ABSENCE, RUNAWAY } from '../../../domain/penalties';
import { useAppDispatch, useAppSelector } from '../../../hooks';
import StepActions from './StepActions';

export default function Step3() {
  const dispatch = useAppDispatch();
  const users = useAppSelector((s) => s.points.users);

  return (
    <Stack className="step3" spacing={2} alignItems="flex-start">
      <Typography variant="h6">Dodaj kary</Typography>
      <TableContainer sx={{ maxWidth: 480 }}>
        <Table size="small">
          <TableHead>
            <TableRow>
              <TableCell sx={{ width: 56 }} />
              <TableCell>Gracz</TableCell>
              <TableCell align="center">{ABSENCE}</TableCell>
              <TableCell align="center">{RUNAWAY}</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users.map((user) => (
              <TableRow key={user._id} hover>
                <TableCell>
                  <Avatar sx={{ width: 32, height: 32 }}>
                    {user.name.slice(0, 1).toUpperCase()}
                  </Avatar>
                </TableCell>
                <TableCell>{user.name}</TableCell>
                <TableCell align="center">
                  <Switch
                    size="small"
                    checked={user.penalties[ABSENCE] ?? false}
                    onChange={(_e, value) => dispatch(penalty(user._id, value, ABSENCE))}
                  />
                </TableCell>
                <TableCell align="center">
                  <Switch
                    size="small"
                    checked={user.penalties[RUNAWAY] ?? false}
                    onChange={(_e, value) => dispatch(penalty(user._id, value, RUNAWAY))}
                  />
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <StepActions
        onBack={() => dispatch(pointsPreviousStep())}
        onNext={() => dispatch(pointsNextStep())}
      />
    </Stack>
  );
}
